import React from "react"

const Accordion = ({
  title,
  description,
  className,
  fillContainer = "false",
  wide = "true",
  children,
}) => {
  return (
    <section
      className={`accordion ${className ?? ""} ${
        fillContainer.toLowerCase() === "true"
          ? "accordion--fill-container"
          : "container-fluid"
      }`}
    >
      <div
        className={`accordion__inner col-xs-12 ${
          wide.toLowerCase() === "false"
            ? "col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2"
            : "col-md-offset-1 col-md-10"
        } center-xs mb-10`}
      >
        {title && <h2>{title}</h2>}
        {description && <p className="mb-8 p--lg">{description}</p>}
        {children}
      </div>
    </section>
  )
}

export default Accordion
